// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"d1338f3c","179":"3977f274"}[chunkId] + ".chunk.js";
};